import { Card } from 'design-system/src/components/Card';
import { Input } from '../Input';
import Button from 'design-system/src/components/Button/Button';
import styled from 'styled-components';
import Logo from 'design-system/src/assets/icons/logoLong.svg?react';
import { CardContent, PageContainer, CardTextSection, CardFormSection } from './styles';
import { EMAIL_VALIDATION_REGEX } from '../../constants';
import { Controller, useForm } from 'react-hook-form';
import { ErrorMessage } from 'design-system/src/components/ErrorMessage/ErrorMessage';
import { requiredErrorString } from '../../utils';
import SignupFlowContent from './SignupFlowContent';

const LogoWrapper = styled.div`
  margin-bottom: 32px;
`;

type SignupFormData = {
  email: string;
};

export type SignupFlowStartProps = {
  className?: string;
  onNext: () => void;
  variant?: 'default' | 'demo';
};

export const SignupFlowStart = ({ className, onNext, variant = 'default' }: SignupFlowStartProps) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<SignupFormData>();

  const onSubmit = (_: SignupFormData) => {
    onNext();
  };

  return (
    <PageContainer className={className}>
      <Card>
        <CardContent>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
          <CardTextSection>
            <SignupFlowContent variant={variant} />
          </CardTextSection>
          <CardFormSection>
            <Controller
              control={control}
              name="email"
              rules={{
                required: { value: true, message: requiredErrorString },
                pattern: {
                  value: EMAIL_VALIDATION_REGEX,
                  message: 'Invalid email',
                },
              }}
              render={({ field }) => (
                <Input label="What's your work email?" type="email" required hasError={!!errors.email} {...field} />
              )}
            />
            {errors.email && <ErrorMessage marginBottom="16px">{errors.email.message}</ErrorMessage>}
            <Button onClick={handleSubmit(onSubmit)} width="full" textStyledAs="bodySmallDMSans" textWeight={700}>
              Get started
            </Button>
          </CardFormSection>
        </CardContent>
      </Card>
    </PageContainer>
  );
};

export default SignupFlowStart;
